import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

type PathBuilderComingSoonDialogProps = {
  open: boolean;
  onClose: () => void;
};

const PathBuilderComingSoonDialog = ({ open, onClose }: PathBuilderComingSoonDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle variant="dialogTitle" align="center">
        {t('pathBuilderComingSoonDialog.title', 'Coming Soon')}
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ py: 3, px: 3 }}>
        <Typography variant="body1" component="p" align="center">
          {t('pathBuilderComingSoonDialog.body', 'The Path Builder will be available in a future release.')}
        </Typography>
      </DialogContent>
      <Divider />
      <DialogActions sx={{ justifyContent: 'center', px: 2, py: 2 }}>
        <Button variant="contained" color="primary" onClick={onClose}>
          {t('button.close', 'Close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PathBuilderComingSoonDialog;
